import React from 'react';
import { CustomListItemType } from '../CustomListItem/CustomListItemComponent';
import CustomListItemContainer from '../CustomListItem/CustomListItemContainer';

export const CustomListItemList: React.FC<{
	items: CustomListItemType[];
}> = ( { items }: { items: CustomListItemType[] } ) => (
	<>
		{ items.map( ( menuItem ) => (
			<CustomListItemContainer key={ menuItem.id } listItem={ menuItem } />
		) ) }
	</>
);
